import { render } from "./Notification.vue?vue&type=template&id=520c6980"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
script.render = render

export default script